import React from 'react';

// Image wrapper component that adds styling similar to the home page
const ServiceImage = ({ src, alt, title }) => {
  return (
    <div className="service-image-container">
      <div className="service-image-wrapper">
        <img 
          src={src} 
          alt={alt || title} 
          className="service-image" 
        />
        {/* Overlay elements to help blend the image */}
        <div className="service-image-glow"></div>
        <div className="service-image-circle service-image-circle-1"></div>
        <div className="service-image-circle service-image-circle-2"></div>
      </div>
    </div>
  );
};

export default ServiceImage;